import React, { useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../context/Store";
import { useLocation } from "react-router-dom";
import SectionTitle from "../components/SectionTitle";
import SingleProject from "../components/SingleProject";
import allMyProjects from "./../data/allMyProjects";
import myInformation from "../data/myInformation";

const Project = ({ paddingTopToDiffer = "pt-10", heightToDiffer = "h-auto" }) => {
  const { setNavLinkActiveName } = useContext(GlobalContext);
  const { pathname } = useLocation();
  const scrollToTop = useRef();

  let delayTime = 0;

  useEffect(() => {
    if (pathname === "/project") scrollToTop.current.scrollIntoView({ behavior: "smooth" });
    setNavLinkActiveName("project");
    document.title = `${myInformation.aboutSection.iAmWhat} | Projects`;
  }, []);

  return (
    <div
      ref={scrollToTop}
      className={`box-border flex h-full w-full flex-col px-8 pt-16 pb-20 sm:px-12 md:h-auto lg:px-16 ${paddingTopToDiffer} ${heightToDiffer}`}
    >
      <div className="flex w-full flex-col items-center gap-4 text-white">
        <SectionTitle title={"Projects,Made"} />
      </div>

      <div className="all_projects mt-8 flex h-auto w-full flex-row flex-wrap justify-center gap-6 gap-y-9">
        {allMyProjects.map((singleElement) => {
          delayTime += 0.05;
          if (delayTime > 0.2) delayTime = 0;

          return (
            <SingleProject
              key={Math.random()}
              images={singleElement.images}
              projectTitle={singleElement.title}
              projectDescription={singleElement.description}
              githubLink={singleElement.githubLink}
              demoLink={singleElement.demoLink}
              animateDelay={delayTime}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Project;
